import type { MetroAnalyticsReporter } from '../interaction/metroAnalyticsReporter'

/**
 * Route-library analytics (cross-platform contract, spec §7). iOS and
 * Android emit the same event name with the same snake_case parameter keys,
 * so the three platforms' rows can be joined; a dropped or renamed key
 * silently splits the funnel.
 *
 * Web emits exactly ONE event from this layer. `discovery_open` is
 * deliberately absent: none of §7's producers (Spotlight, widget, App
 * Intent, app search) exists on web, and an SEO landing on a prerendered
 * route page is a page view web analytics already counts. Adding a fake
 * emission site to "activate" the name is forbidden by the spec.
 */
const EVENT_ROUTE_HISTORY_RECORDED = 'route_history_recorded'

/**
 * Emit `route_history_recorded { route_key, changes_count, duration_minutes }`.
 *
 * Fired on the WRITE, not on the tap: the funnel exists to tell "opened
 * details" apart from "recorded to history", and a pair that cannot form a
 * key produces neither.
 */
export function reportRouteHistoryRecorded(
  reporter: MetroAnalyticsReporter,
  params: { routeKey: string; changesCount: number; durationMinutes: number },
): void {
  reporter(EVENT_ROUTE_HISTORY_RECORDED, {
    route_key: params.routeKey,
    changes_count: params.changesCount,
    duration_minutes: params.durationMinutes,
  })
}
